export function isFalsyOrEmpty(obj) 
{
  if(!obj)
    return true;
  for(var key in obj) {
          return false;
  }
  return true;
} 